"use client";
import useOnline from "../../../hooks/useOnline/index.js";
import useTabFocus from "../../../hooks/useTabFocus/index.js";
import useVisibility from "../../../hooks/useVisibility/index.js";
export const Stores = () => {
    useOnline();
    useTabFocus();
    useVisibility();
    return null;
};
